const Countdown = () => {
  const now = new Date();
  const countDate = new Date("March 25 2026 23:59:59 GMT-0400").getTime();
  const gap = countDate - now;

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const textDay = Math.floor(gap / day);
  const textHour = Math.floor((gap % day) / hour);
  const textMinute = Math.floor((gap % hour) / minute);
  const textSecond = Math.floor((gap % minute) / second);
  const textMillisecond = (gap % 1000) / 1000;
  const msString = String(Math.floor(textMillisecond * 100)).padStart(2, "0"); // Truncate to 2 digits

  const pad = (num, digits = 2) => String(num).padStart(digits, "0");

  if (gap >= 0){
    document.querySelector('.day').innerText = pad(textDay);
    document.querySelector('.hour').innerText = pad(textHour);
    document.querySelector('.minute').innerText = pad(textMinute);

    const dayContainer = document.querySelector('.container-day');
    const secondEl = document.querySelector('.second');
      // Add seconds + millisecond span
      secondEl.innerHTML = `${pad(textSecond)}`;
  }
};

setInterval(Countdown, 25);





    const progress1 = document.querySelector('.progress1');
    const progressBackground = document.querySelector('.progress-bg');
    const progressBar = document.getElementById('progress-bar');
    const transitionDuration = 750;

    // Convert EST time based on UTC offset
    function getNewYorkTime() {
        const now = new Date();
        const localTime = now.getTime();
        const localOffset = now.getTimezoneOffset() * 60000;
        const utcTime = localTime + localOffset;
        const offsetEST = -5; // adjust for EDT
        return new Date(utcTime + (3600000 * offsetEST));
    }

    const beginTime = new Date("March 17, 2026 00:00:00").getTime();
    const endTime = new Date("March 25, 2026 23:59:59").getTime();
    const fullDuration = endTime - beginTime;

    // Get current progress value as a decimal (0.0 to 1.0)
    function getProgressFraction() {
        const now = getNewYorkTime().getTime();
        return (now - beginTime) / fullDuration;
    }

    // Calculate progress width as a percent string
    function calculateWidth(fraction) {
        if (fraction <= 0) return '0%';
        if (fraction >= 1) return '100%';
        if (fraction * 100 < 60) return '0%'; // hidden under 60%
        return (60 + (fraction * 40)) + '%';
        // return (fraction * 100) + '%';
    }

    // Step 1: Animate once on load
    function initProgressBar() {
        const fraction = getProgressFraction();
        // console.log("FRACTION OF TIME PASSED: " + fraction);
        const width = calculateWidth(fraction);
        // console.log("WIDTH TO GO TO: " + width);

        if (fraction <= 0 || fraction >= 1 || fraction * 100 < 60) {
            // console.log("current time is not within progress bar start and end times")
            return;
        }

        setTimeout(() => {

            // Grow Progress Bar
            progressBackground.style.height = '30px';
            progress1.style.height = '30px';

            // Animate to current progress
            setTimeout(() => {
                progress1.style.width = width;
            }, 250);

            // Start Live Updates Afterward
            setTimeout(startLiveProgressUpdates, transitionDuration + 100);
        }, 100);

    }

    // Step 2: Continuous updates after initial animation
    function startLiveProgressUpdates() {
        setInterval(() => {
            const fraction = getProgressFraction();
            const width = calculateWidth(fraction);

            // Update width
            // progress1.style.transition = 'none';
            progress1.style.width = width;

            // Reset transition after updating
            requestAnimationFrame(() => {
                progress1.style.transition = 'width .75s ease-in-out';
            });
        }, 1000);
    }

    // Start the system
    initProgressBar();



window.addEventListener("DOMContentLoaded", () => {
  const sideBar = document.getElementById("popUpTrigger");
  const banners = document.querySelectorAll(".popUpTrigger");
  const popup = document.getElementById("fs-popup");
  const closeBtn = document.getElementById("exit-icon");
  const copyBox = document.getElementById("copyBox");
  const bonusCode = document.getElementById("bonusCode");
  const successMsg = document.getElementById("successMsg");
  const popupContent = popup.querySelector(".bonus-popup-content");

  let autoCloseTimeout = null; // track pending auto-close timer

  // 🟢 Open popup
  banners.forEach(banner => {
    banner.addEventListener("click", () => {
    clearTimeout(autoCloseTimeout); // prevent leftover timers
    successMsg.classList.add("hidden"); // reset success message
    popup.classList.remove("hidden");
    popup.classList.add("show");
  });
  })
  


  // banner.addEventListener("click", () => {
  //   clearTimeout(autoCloseTimeout); // prevent leftover timers
  //   successMsg.classList.add("hidden"); // reset success message
  //   popup.classList.remove("hidden");
  //   popup.classList.add("show");
  // });

  // 🟣 Close popup with zoom-out animation
  function closePopup() {
    clearTimeout(autoCloseTimeout);            // stop any pending timer
    successMsg.classList.add("hidden");        // ALWAYS hide success message

    popup.classList.add("closing");            // fade overlay
    popupContent.classList.add("closing");     // zoom-out content

    setTimeout(() => {
      popup.classList.remove("show", "closing");
      popupContent.classList.remove("closing");
    }, 300); // matches popupOut duration
  }

  // 🔴 Close with X button
  closeBtn.addEventListener("click", closePopup);

  // 🔵 Close by clicking outside
  popup.addEventListener("click", (e) => {
    if (e.target === popup) closePopup();
  });

  // 🟡 Copy code → show success + auto-close
  copyBox.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(bonusCode.textContent);

      successMsg.classList.remove("hidden");

      clearTimeout(autoCloseTimeout); // clear previous timer if any
      autoCloseTimeout = setTimeout(() => {
        closePopup();                 // this also hides the success message
      }, 5000);

    } catch (err) {
      console.error("Clipboard copy failed:", err);
    }
  });
});
